import { Card } from "@cpchem/covalence-ui";
import "./styles.scss";
import { ReactNode } from "react";

interface SectionProps {
    id?: string;
    className?: string;
    children?: ReactNode | ReactNode[];
}

export function Section({ id, className, children }: SectionProps) {
    let cn = "section";
    if (className) {
        cn += ` ${className}`;
    }
    return (
        <section id={id} className={cn}>
            <Card className="card" gap>
                {children}
            </Card>
        </section>
    );
}
